module.exports = __webpack_public_path__ + "img/product_04_pic@2x.e9586df8.png";